import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

let state = {
  user: null,
  role: null,
  accessToken: null,
  isAuthenticated: false,
};

const listeners = new Set();

function notify() {
  listeners.forEach((fn) => fn(state));
}

export function getState() {
  return state;
}

export function getAccessToken() {
  return state.accessToken || sessionStorage.getItem('accessToken');
}

export function setAccessToken(token) {
  state = { ...state, accessToken: token };
  sessionStorage.setItem('accessToken', token);
  notify();
}

export function setAuth(user, accessToken, role) {
  state = { user, role: role || null, accessToken, isAuthenticated: true };
  sessionStorage.setItem('accessToken', accessToken);
  notify();
}

export function clearAuth() {
  state = { user: null, role: null, accessToken: null, isAuthenticated: false };
  sessionStorage.removeItem('accessToken');
  localStorage.removeItem('isSignin');
  localStorage.removeItem('userType');
  localStorage.removeItem('adminData');
  localStorage.removeItem('studio-owner');
  localStorage.removeItem('isStudioSupported');
  localStorage.removeItem('token');
  notify();
}

export async function logout() {
  try {
    // credentials so the backend can clear the httpOnly refreshToken cookie
    await api.post('/users/logout', {}, { withCredentials: true });
  } catch (e) {
    // ignore logout API errors
  } finally {
    clearAuth();
  }
}

export function useAuthStore(selector) {
  const [slice, setSlice] = useState(() => selector(state));

  const handleChange = useCallback(
    (newState) => {
      const next = selector(newState);
      setSlice((prev) => (Object.is(prev, next) ? prev : next));
    },
    [selector]
  );

  useEffect(() => {
    listeners.add(handleChange);
    handleChange(state);
    return () => listeners.delete(handleChange);
  }, [handleChange]);

  return slice;
}
